import React                    from 'react';
import { Observe }              from 'rewire-core';
import {
  WithStyle,
  FormView
}                               from 'rewire-ui';
import { Theme }                from '@material-ui/core/styles';
import Dialog                   from '../ui/Dialog';
import searchViewDialogModel    from './SearchViewDialogModel';
import { withStyles }           from '../utility/styles';

const styles = (_theme: Theme) => ({
});

interface ISearchViewDialogProps {
}

type SearchViewDialogProps = WithStyle<ReturnType<typeof styles>, ISearchViewDialogProps>;

class SearchViewDialog extends React.PureComponent<SearchViewDialogProps> {
  constructor(props: SearchViewDialogProps) {
    super(props);
  }

  componentWillUnmount() {
    searchViewDialogModel.reset();
  }

  renderDialogContents = React.memo((): JSX.Element => {
    return <Observe render={() => (
      <FormView form={searchViewDialogModel.form} onSubmit={searchViewDialogModel.actionFn('save')}>
        <Observe render={() => (
          searchViewDialogModel.form.fields.map((field: any) => (
            field.visible
              ? <div key={field.name} className='content'>
                  <field.Editor className='span1' />
                </div>
              : null
          ))
        )} />
      </FormView>
    )} />;
  });

  render() {
    return <Observe render={() => (
      <Dialog maxWidth='md' dialog={searchViewDialogModel}>
        <this.renderDialogContents />
      </Dialog>
    )} />;
  }
}

export default withStyles<ISearchViewDialogProps>(styles, SearchViewDialog);
